module.exports = __webpack_public_path__ + "img/IMG_8993.735fbe3d.jpg";